import { Route } from 'react-router-dom';

import { SettingsQueuesView } from './settingsQueues.view';
import { SettingsQueuesCreateView } from './views/create';
import { SettingsQueuesEditView } from './views/edit';

export const settingsQueuesRoutes = (
  <Route path="queues">
    <Route path="" element={<SettingsQueuesView />} />
    <Route path="create" element={<SettingsQueuesCreateView />} />
    <Route path=":id" element={<SettingsQueuesEditView />} />
  </Route>
);
